(() => {
  const defineCE = (name, ctor) => {
    if (!window.customElements.get(name)) {
      window.customElements.define(name, ctor);
    }
  };

  class SubscriptionWidget extends HTMLElement {
    connectedCallback() {
      this._cacheElements();
      this._reconcileFormAssociation();
      this._bindEvents();
      this._syncFromDefault();
    }

    disconnectedCallback() {
      this._unbindEvents();
    }

    _cacheElements() {
      this.sellingPlanInput = this.querySelector("[data-subscription-selling-plan]");
      this.optionEls = Array.from(this.querySelectorAll("[data-subscription-option]"));
      this.planInputs = Array.from(this.querySelectorAll("[data-subscription-plan-input]"));
      this.priceCurrentEl = this.querySelector("[data-subscription-price-current]");
      this.priceCompareEl = this.querySelector("[data-subscription-compare-at]");
      this.intervalEl = this.querySelector(".interval");

      this.currency = this.dataset.currency || "EUR";
      this.locale = this.dataset.locale || "de";
      this.defaultOption = this.dataset.defaultOption || "subscription";
    }

    _reconcileFormAssociation() {
      if (!this.sellingPlanInput) return;

      const ownerForm = this.closest('form[is="product-form"]') || this.closest("form");
      if (!ownerForm?.contains(this.sellingPlanInput)) {
        if (ownerForm?.id) {
          this.sellingPlanInput.setAttribute("form", ownerForm.id);
        }
        return;
      }

      // Partial section swaps can render a stale product_form_id while the outer form id stays unchanged.
      this.sellingPlanInput.removeAttribute("form");
    }

    _bindEvents() {
      this._onOptionClick = this._onOptionClick.bind(this);
      this._onPlanChange = this._onPlanChange.bind(this);
      this._onIntervalClick = this._onIntervalClick.bind(this);

      this.optionEls.forEach((option) => {
        option.addEventListener("click", this._onOptionClick);
      });

      this.planInputs.forEach((input) => {
        input.addEventListener("change", this._onPlanChange);
      });

      if (this.intervalEl) {
        this.intervalEl.addEventListener("click", this._onIntervalClick);
      }
    }

    _unbindEvents() {
      this.optionEls.forEach((option) => {
        option.removeEventListener("click", this._onOptionClick);
      });

      this.planInputs.forEach((input) => {
        input.removeEventListener("change", this._onPlanChange);
      });

      if (this.intervalEl) {
        this.intervalEl.removeEventListener("click", this._onIntervalClick);
      }
    }

    _onIntervalClick(event) {
      event.stopPropagation();
    }

    _onOptionClick(event) {
      const option = event.currentTarget;
      const purchaseType = option.dataset.subscriptionOption;
      if (!purchaseType) return;

      this.optionEls.forEach((el) => el.classList.remove("selected"));
      option.classList.add("selected");

      const isSubscription = purchaseType === "subscription";
      this._setSellingPlanEnabled(isSubscription);
      this._toggleSubscriptionOnlyElements(isSubscription);

      if (isSubscription) {
        this._syncSellingPlanFromSelection();
      }
    }

    _onPlanChange() {
      this._syncSellingPlanFromSelection();
    }

    _syncFromDefault() {
      const isSubscription = this.defaultOption === "subscription";
      this._setSellingPlanEnabled(isSubscription);
      this._toggleSubscriptionOnlyElements(isSubscription);

      if (isSubscription) {
        this._syncSellingPlanFromSelection();
      }
    }

    _getSelectedPlanInput() {
      return this.planInputs.find((input) => input.checked) || this.planInputs[0] || null;
    }

    _syncSellingPlanFromSelection() {
      const selectedInput = this._getSelectedPlanInput();
      if (!selectedInput || !this.sellingPlanInput) return;

      this.sellingPlanInput.value = selectedInput.value;

      const pill = selectedInput.closest("[data-selling-plan-id]");
      if (!pill) return;

      const price = parseInt(pill.dataset.price || "0", 10);
      const compareAt = parseInt(pill.dataset.compareAt || "0", 10);

      if (this.priceCurrentEl) {
        this.priceCurrentEl.textContent = this._formatMoney(price);
      }

      if (this.priceCompareEl) {
        if (compareAt > price) {
          this.priceCompareEl.textContent = this._formatMoney(compareAt);
          this.priceCompareEl.hidden = false;
        } else {
          this.priceCompareEl.hidden = true;
        }
      }
    }

    _setSellingPlanEnabled(enabled) {
      if (!this.sellingPlanInput) return;

      if (enabled) {
        this.sellingPlanInput.disabled = false;
        this._syncSellingPlanFromSelection();
      } else {
        this.sellingPlanInput.disabled = true;
      }
    }

    _toggleSubscriptionOnlyElements(isSubscription) {
      document.querySelectorAll(".show-with-subscription-only").forEach((el) => {
        el.style.display = isSubscription ? "" : "none";
      });
      this._toggleShippingText(isSubscription);
    }

    _toggleShippingText(isSubscription) {
      const subscriptionShippingHtml = "<strong>Kostenloser Versand</strong>";

      document
        .querySelectorAll(".desktop-shipping-text:not(.show-with-subscription-only) .text-desktop-shipping")
        .forEach((el) => {
          if (!el.dataset.originalShippingHtml) {
            el.dataset.originalShippingHtml = el.innerHTML;
          }
          el.innerHTML = isSubscription ? subscriptionShippingHtml : el.dataset.originalShippingHtml;
        });
    }

    _formatMoney(cents) {
      const locale = this.locale.includes("-") ? this.locale : `${this.locale}-${this.locale.toUpperCase()}`;
      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: this.currency,
      }).format(cents / 100);
    }
  }

  defineCE("subscription-widget", SubscriptionWidget);
})();
